/**
 * Daily To-Do List - JavaScript functionality
 * Handles confirmation dialogs and scroll position
 */
(function () {
    'use strict';

    /**
     * Initialize the daily to-do list
     */
    function init() {
        // Restore scroll position if returning from form submission
        restoreScrollPosition();

        // Save scroll position before form submissions
        const form = document.getElementById('dailyTodoForm');
        if (form) {
            form.addEventListener('submit', saveScrollPosition);
        }

        initClearConfirmation();
    }

    /**
     * Save current scroll position to sessionStorage before form submission
     * Skips saving if the confirmation modal is visible to preserve the original position
     */
    function saveScrollPosition() {
        const modalOverlay = document.querySelector('.clear-confirmation-overlay.is-visible');
        if (modalOverlay) {
            return;
        }

        try {
            sessionStorage.setItem('dailyTodoListScrollPos', window.pageYOffset.toString());
        } catch (e) {
            // Ignore storage errors
        }
    }

    /**
     * Restore scroll position from sessionStorage after page load
     * Only removes saved position when modal is not visible (to support Confirm/Cancel flow)
     */
    function restoreScrollPosition() {
        try {
            const scrollPos = sessionStorage.getItem('dailyTodoListScrollPos');
            if (scrollPos) {
                window.scrollTo(0, parseInt(scrollPos, 10));
                
                const modalOverlay = document.querySelector('.clear-confirmation-overlay.is-visible');
                if (!modalOverlay) {
                    sessionStorage.removeItem('dailyTodoListScrollPos');
                }
            }
        } catch (e) {
            // Ignore storage errors
        }
    }

    /**
     * Initialize clear confirmation modal controls
     */
    function initClearConfirmation() {
        const clearButton = document.getElementById('dailyTodoListClear');
        const overlay = document.getElementById('clearConfirmationOverlay');
        if (!clearButton || !overlay) {
            return;
        }

        const closeButtons = overlay.querySelectorAll('[data-clear-confirmation="close"]');

        clearButton.addEventListener('click', function () {
            openClearConfirmation(overlay);
        });

        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                closeClearConfirmation(overlay);
            });
        });
    }

    /**
     * Open the clear confirmation modal
     * @param {HTMLElement} overlay The modal overlay element
     */
    function openClearConfirmation(overlay) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('clear-confirmation-open');
    }

    /**
     * Close the clear confirmation modal
     * @param {HTMLElement} overlay The modal overlay element
     */
    function closeClearConfirmation(overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('clear-confirmation-open');
        document.body.style.paddingRight = '';
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose public API
    window.DailyTodoList = {};
})();
